export class EntityConstants {
  public static readonly ENTITY_TYPES = {
    MNE: 'MNE',
    ENTITY: 'Entity',
  };
}
